const RequestTypesEnum = {
    CLUB_REGISTRATION: "ClubRegistration",
    CLUB_UPDATE: "ClubUpdate",
    CLUB_JOIN: "ClubJoin",
    CLUB_TRANSFER: "ClubTransfer",
    CLUB_HOSTING: "ClubHosting",
    PERSON_PROFILE_UPDATE: "PersonProfileUpdate"
}
export default RequestTypesEnum;
